/**
 * Where to send a shopper back to after they authenticate from the wishlist drawer.
 *
 * The loyalty drawer's own login paths both finish with a redirect out to Omneo and back, and by
 * default they come back to the profile: `mobileLogin` hardcoded `urlPath=/account`, and the email
 * magic link passes `window.location.pathname`. Opened from the header that is the right landing
 * page, but a shopper who was saving a product to a wishlist should come back to that product.
 *
 * So the wishlist drawer records the page it was opened from and the login paths prefer it. The
 * value is read once and cleared, so a later sign-in from the header is unaffected.
 */
export const WISHLIST_LOGIN_FLAG = 'wishlistLoginReturn'

/** Stores the current URL, path and query, as the post-login destination. */
export const rememberWishlistLoginReturn = (): void => {
  try {
    sessionStorage.setItem(WISHLIST_LOGIN_FLAG, window.location.pathname + window.location.search)
  } catch (error) {
    // Private browsing can refuse the write; login still works, it just lands on the profile.
  }
}

/** Reads and clears the stored destination. Returns null when the drawer was not the origin. */
export const takeWishlistLoginReturn = (): string | null => {
  try {
    const stored = sessionStorage.getItem(WISHLIST_LOGIN_FLAG)
    if (stored) sessionStorage.removeItem(WISHLIST_LOGIN_FLAG)
    return stored || null
  } catch (error) {
    return null
  }
}
